<template>
    <div id="pz">
     <div class="dokpz">
        <div class="title">{{ title }}</div>
	<div class="items">
		<div id='container' class='e-resizable'>
     		<ejs-grid ref="grid" :dataSource="data" :allowPaging="false" :allowSorting="true" :allowGrouping="false" :selectionOptions="selectionOptions" :rowSelected="rowSelected" :rowDeselected="rowSelected" :allowTextWrap='true' locale='pl-PL' :allowFiltering="true" :filterSettings="filterOptions" :rowHeight="80" height="100%" width="100%"> 
			<e-columns>
				<e-column field='ID_DOK_MAGAZYNOWEGO' headerText='ID' :visible="false"></e-column>
				<e-column field='numerPZ' headerText='Numer PZ' width='100'></e-column>
				<e-column field='dataPZ' headerText='Data PZ' type='date' format='yyyy-MM-dd' width='80'></e-column>
				<e-column field='nazwaKontrahenta' headerText='Nazwa kontrahenta' width='250'></e-column>
				<e-column field='nazwaArtykulu' headerText='Nazwa artykułu' width='100'></e-column>
				<e-column field='iloscArtykulu' headerText='Ilość artykułu' width='100' :allowFiltering="false"></e-column>
				<e-column field='iloscSkrzyn' headerText='Ilość skrzyń' width='100' :allowFiltering="false"></e-column>
            			<!--<e-column type='checkbox' width='50'></e-column>-->
			</e-columns>
		</ejs-grid>
		</div>
	</div>
     </div>
     <div class="wleft">
        <button class="wlabel">WRÓĆ</button>
     </div>
     <div class="wright">
	<button class="wlabel"> DRUKUJ ETYKIETĘ </button>
     </div>
    </div>
</template>

<script>

import Vue from "vue";
import { GridPlugin, Page, Sort, Filter, Group } from "@syncfusion/ej2-vue-grids";
//import { L10n, setCulture } from '@syncfusion/ej2-base';
import { dokumenty_pz } from "./panel1_dane.js";
import * as CONFIG from "./config.js";
import axios from "axios";
import { polish } from "./polish.js";
import Storage from "./Storage";

//setCulture('pl-PL');

axios.defaults.withCredentials = false;

Vue.use(GridPlugin);


export default {
  name: "dokumentypz",
  props: {
    groupTitle: String,
    dataLoading: Boolean,
  },
  data: () => ({
	//data: dokumenty_pz.items,
	data: [],
	url: "/agent/GALEK.Magazyn/GetDokumentPZ",
	title: "PRZYJĘCIE NA MAGAZYN > LISTA DOKUMENTÓW PZ",
	x: 1,
        //pageSettings: { pageSize: 5 },
        selectionOptions: { allowColumnSelection: false, type: "Single" },
	gitem: { },
	filterOptions: {
        type: 'Menu',
        operators: {
          stringOperator: [
            { value: 'startsWith', text:'startsWith' },
            { value: 'endsWith', text:'endsWith' },
            { value: 'contains', text:'contains' }
          ],
        }
	},
	jwt: "",
   }),
   provide: {
	grid: [Page, Sort, Filter]
   },
   methods: { 
	dataBound: function() {
        	//this.$refs.grid.autoFitColumns();
    	},
	rowSelected(args) {
        	//let selectedrowindex = this.$refs.grid.getSelectedRowIndexes();  // Get the selected row indexes.
        	//alert(selectedrowindex); // To alert the selected row indexes.
        	let selectedrecords = this.$refs.grid.getSelectedRecords();  // Get the selected records.
		if (selectedrecords.length > 0) {
			this.gitem = selectedrecords[0];		
			//alert(JSON.stringify(this.gitem));
		} else {
			this.gitem = {};
		}
	},
	drukujclick() {
		//alert("Drukuj");
		if (this.gitem && this.gitem.ID_DOK_MAGAZYNOWEGO) {
			this.$router.push({ path: "/etykieta", query: { item: this.gitem.ID_DOK_MAGAZYNOWEGO }});
		} else {
			alert("Nie wybrano elementu do druku. Proszę zaznaczyć dokładnie 1 element z listy.");
		}
	},
	wrocclick() {
		this.$router.push({ path: "/main" });
	},
	getData() {
      		return axios
        		.get(CONFIG.API_URL + this.url, {
          		headers: {
            			"Content-Type": "application/x-www-form-urlencoded",
            			"Accept": "application/json",
				"Authorization": "Bearer " +  this.jwt,
          		}
        		})
        		.then(response => {
          			return response.data;
        		})
        		.catch(e => {
          			alert("ERROR" + e);
        		});
	},
   },
   mounted() {
	var that = this;
	Storage.loadJWT("jwt").then(resp => {
		//alert(resp.access_token);
		that.jwt = resp.access_token;
		that.getData().then(data => {
			that.data = data;
		});
	});
	document.querySelector(".wright").addEventListener('click', function() { that.drukujclick(); } );
	document.querySelector(".wleft").addEventListener('click', function() { that.wrocclick(); } );
   }
};

</script>

<style>
  @import "../../node_modules/@syncfusion/ej2-vue-grids/styles/material.css";

.e-resizable {
  resize: both;
  overflow: auto;
  /*border: 1px solid red;*/
  padding: 1px;
  height: 500px;
  min-height: 550px;
  min-width: 250px;
}

.title {
	text-align: left;
	width: 100%;
}
.items {
	float:none;
}
.dokpz {
	float: left;
	width: 100%;
	padding: 0% 0% 0% 0%;
}
.wright {
	width: 200px;
	height: 50px;
    position:fixed;
	bottom: 10px;
	right: 10px;
	text-align: right;
	background-color: #FFFFFF;
	/*padding-top: 10px;*/
	float: right;
	margin-top: 40px;
}
.wleft {
	width: 200px;
	height: 50px;
	position:fixed;
	bottom: 10px;
	text-align: left;
	background-color: #FFFFFF;
	float: left;
	margin-top: 40px;
	/*margin-left: 400px;*/
}
.wlabel {
        width: 200px;
        height: 50px;
        position:relative;
        background-color: #FFFFFF;
}
</style>



// WEBPACK FOOTER //
// src/components/DokumentPZ.vue